import topic from '../topic';
export const suppAPI = {
  getSupps: topic.suppTopic + '/get_supps',
  getSuppById: topic.suppTopic + '/get_supp_by_id',
  addSupp: topic.suppTopic + '/add_supp',
  editSupp: topic.suppTopic + '/edit_supp',
  deleteSuppByIds: topic.suppTopic + '/delete_supp_by_ids',
  getSuppsV1: topic.suppTopic + '/get_supps_v1'
};
